import React, { useState } from "react";
import { Pencil, Trash2, Paperclip, Zap, User } from "lucide-react";
import { fmtEUR } from "../../lib/api";

const PER = 10;
const itDate = (d) => d.split("-").reverse().join("/");

export function EvChargesTable({ rows, onEdit, onDelete, onReceipt }) {
  const [page, setPage] = useState(0);
  const pages = Math.max(1, Math.ceil(rows.length / PER));
  const p = Math.min(page, pages - 1);
  const view = rows.slice(p * PER, p * PER + PER);
  return (
    <div className="rounded-2xl border border-[#D4A72C]/20 bg-[#0A0907]/90 p-4 md:p-5" data-testid="ev-table">
      <div className="font-display text-lg text-white inline-flex items-center gap-2 mb-3"><Zap size={18} className="text-[#E9C46A]" />Elenco ricariche</div>
      {!rows.length ? <div className="py-10 text-center text-sm text-slate-500" data-testid="ev-empty">Nessuna ricarica registrata per i filtri scelti</div> : (
        <div className="overflow-x-auto -mx-1">
          <table className="w-full min-w-[720px] text-sm">
            <thead><tr className="text-left text-[11px] uppercase tracking-wider text-slate-500 border-b border-white/10">
              {["Data", "Autista", "Veicolo", "Targa", "Importo", "Nota", ""].map((h) => <th key={h} className="py-2.5 px-2 font-medium">{h}</th>)}
            </tr></thead>
            <tbody>
              {view.map((r) => (
                <tr key={r.id} className="border-b border-white/5 hover:bg-[#D4A72C]/[0.04]" data-testid={`ev-row-${r.id}`}>
                  <td className="py-2.5 px-2 font-mono-num text-slate-200">{itDate(r.date)}</td>
                  <td className="py-2.5 px-2 text-slate-200"><span className="inline-flex items-center gap-1.5"><User size={13} className="text-[#C9A961]" />{r.driver_name}</span></td>
                  <td className="py-2.5 px-2 text-slate-200">{r.vehicle_label}</td>
                  <td className="py-2.5 px-2 font-mono-num text-slate-300">{r.plate}</td>
                  <td className="py-2.5 px-2 font-mono-num text-white font-semibold" data-testid={`ev-row-amount-${r.id}`}>{fmtEUR(r.amount)}</td>
                  <td className="py-2.5 px-2 text-slate-400 max-w-[200px] truncate">{r.note || "—"}</td>
                  <td className="py-2.5 px-2 whitespace-nowrap text-right">
                    {r.has_receipt && <button type="button" title="Apri ricevuta" onClick={() => onReceipt(r)} className="p-1.5 text-[#E9C46A] hover:text-white" data-testid={`ev-receipt-${r.id}`}><Paperclip size={15} /></button>}
                    <button type="button" title="Modifica" onClick={() => onEdit(r)} className="p-1.5 text-slate-300 hover:text-[#E9C46A]" data-testid={`ev-edit-${r.id}`}><Pencil size={15} /></button>
                    <button type="button" title="Elimina" onClick={() => onDelete(r)} className="p-1.5 text-rose-400 hover:text-rose-300" data-testid={`ev-delete-${r.id}`}><Trash2 size={15} /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {rows.length > PER && (
        <div className="flex items-center justify-between mt-3 text-xs text-slate-400" data-testid="ev-pagination">
          <span>{rows.length} ricariche</span>
          <div className="flex gap-1">
            {Array.from({ length: pages }).map((_, i) => (
              <button key={i} type="button" onClick={() => setPage(i)} className={`w-8 h-8 rounded-md ${i === p ? "bg-[#D4A72C] text-black font-bold" : "border border-white/10 hover:border-[#D4A72C]/50"}`} data-testid={`ev-page-${i + 1}`}>{i + 1}</button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
